import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["id", "placeholder"]
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "color-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-field-floating lg reactive full form-field-with-prefix", _ctx.classesNames])
  }, [
    _withDirectives(_createElementVNode("select", {
      class: "form-input-prefix",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.indicatif) = $event)),
      name: "indicatif",
      id: "indicatif"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
        return (_openBlock(), _createElementBlock("option", {
          key: country.code,
          value: country.dial
        }, _toDisplayString(country.dial), 9, _hoisted_1))
      }), 128))
    ], 512), [
      [_vModelSelect, _ctx.formData.indicatif]
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: "form-input",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.telephone) = $event)),
      name: "telephone",
      id: _ctx.inputId,
      placeholder: _ctx.placeholder
    }, null, 8, _hoisted_2), [
      [_vModelText, _ctx.formData.telephone]
    ]),
    _createElementVNode("label", { for: _ctx.inputId }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("b", _hoisted_4, "*"))
        : _createCommentVNode("", true)
    ], 8, _hoisted_3)
  ], 2))
}